class ApiService {
  constructor ($log, $http, $window, $rootScope, Localization, I18n) {
    'ngInject'
    this.$log = $log
    this.$http = $http
    this.$window = $window
    this.$rootScope = $rootScope
    this.endpoint = Localization.getLocalizedAppConfig().endpoint
    this.useCache = Localization.getLocalizedAppConfig().useCache
    this.defaultHeaders = {
      'X-Locale': I18n.getLanguage(),
      'X-Country': Localization.getCountry()
    }
    this.initCache()

    $rootScope.$on('user:logout', (event, data) => {
      this.initCache()
    })

    $rootScope.$on('language:changed', (event, data) => {
      this.defaultHeaders['X-Locale'] = data
    })
  }

  initCache () {
    this.cache = {}
  }

  getFromCache (key) {
    if (!this.useCache) {
      return null
    }
    // this.$log.debug('Try to get object from cache:', key)
    key = this._getCacheKey(key)
    if (this.cache[key]) {
      // this.$log.debug('Get object from cache:', key)
      return this.cache[key]
    }
    return null
  }

  putInCache (key, obj) {
    if (!this.useCache) {
      return null
    }
    // this.$log.debug('Put object into the cache:', key)
    this.cache[this._getCacheKey(key)] = obj
  }

  _getCacheKey (obj) {
    const str = JSON.stringify(obj)
    let hash = 0
    if (str.length === 0) return hash
    for (let i = 0; i < str.length; i++) {
      const chr   = str.charCodeAt(i)
      hash = ((hash << 5) - hash) + chr
      hash |= 0 // Convert to 32bit integer
    }
    // this.$log.debug('Calculated hash:', hash)
    return `h${hash}`
  }

  _setDefaultHeaders (config = {}) {
    config.headers = Object.assign(
      {},
      this.defaultHeaders,
      config.headers
    )
    return config
  }

  post (url, body, config) {
    config = this._setDefaultHeaders(config)
    return this.$http.post(this.endpoint + url, body, config)
  }

  get (url, config) {
    config = this._setDefaultHeaders(config)
    return this.$http.get(this.endpoint + url, config)
  }

  put (url, body, config) {
    config = this._setDefaultHeaders(config)
    return this.$http.put(this.endpoint + url, body, config)
  }

  delete (url, config) {
    config = this._setDefaultHeaders(config)
    return this.$http.delete(this.endpoint + url, config)
  }
}

export default ApiService



// WEBPACK FOOTER //
// ./src/app/services/common/api.service.js